import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectChangeEventDetail, SelectCustomEvent } from '@ionic/core';
import { CartsData } from 'src/app/interfaces/api/cart';
import { PricingShipment } from 'src/app/interfaces/api/shipment';
import { MHProduct } from 'src/app/interfaces/api/product';
import { ShipmentService } from 'src/app/services/shipment.service';
import { transformWeight } from 'src/helpers';

@Component({
  selector: 'app-product-checkout',
  templateUrl: './product-checkout.component.html',
  styleUrls: ['./product-checkout.component.scss'],
})
export class ProductCheckoutComponent implements OnInit {
  @Input() itemsPerWarehouse: CartsData[];
  @Input() warehouseId: number;
  @Input() warehouse: string;
  @Input() subtotal: number;
  @Output() selectCourier = new EventEmitter();
  @Output() changeStatusCover = new EventEmitter();
  listCouriers: PricingShipment[] = [];
  selectedCourier: PricingShipment;
  useCover = false;

  customAlertOptions = {
    header: 'Select Courier',
    // subHeader: '',
    // message: 'Choose only one',
    // translucent: true,
  };

  constructor(private shipmentService: ShipmentService) {}

  ngOnInit() {}

  formattedFakePrice(item: MHProduct, qty: number) {
    return item.fake_price * qty;
  }

  formattedPriceCount(item: MHProduct, qty: number) {
    return item.price_after_discount * qty;
  }

  formattedBaseDiscount(base_discount: string) {
    return parseFloat(base_discount);
  }

  formatmWeight(num: number) {
    return transformWeight(num);
  }

  onSelectCourier(event: Event) {
    const customEvent = event as CustomEvent<SelectChangeEventDetail>;
    const courierCode = customEvent.detail.value;
    this.selectedCourier = this.listCouriers.find(item => item.courier_code_with_courier_service_code === courierCode);
    this.selectCourier.emit({ warehouseId: this.warehouseId, selectedCourier: this.selectedCourier });
  }

  getListCouriers() {
    if (this.listCouriers.length > 1) {
      return;
    }

    let cartIds = '';
    this.itemsPerWarehouse.forEach((item, index) => {
      cartIds += item.id;

      if (index + 1 !== this.itemsPerWarehouse.length) {
        cartIds += ',';
      }
    });

    const selfService: PricingShipment[] = [
      {
        courier_code: '0',
        courier_name: 'Ambil Dari Gudang',
        courier_service_name: null,
        courier_service_code: null,
        price: 0,
        courier_code_with_courier_service_code: '0',
      },
    ];
    this.listCouriers = [...selfService];
    this.shipmentService.getListShipment(this.itemsPerWarehouse[0].id_mh_warehouse, cartIds).subscribe({
      next: val => {
        this.listCouriers = [
          ...this.listCouriers,
          ...val.data.rate.pricing?.map(x => ({
            ...x,
            courier_code_with_courier_service_code: x.courier_code + '|' + x.courier_service_code,
          })),
        ];
        // console.log(this.listCouriers);
      },
      complete: () => {
        console.log('complete');
      },
      error: err => {
        console.log('error', err);
        // this.listCouriers = [...selfService];
      },
    });
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  changeUseCover(status: boolean, product_id: number) {
    // this.useCover = status;
    this.itemsPerWarehouse.find(item => item.id_mh_product === product_id).use_cover = status;
    this.changeStatusCover.emit({ warehouseId: this.warehouseId, statusCover: status, productId: product_id });
  }
}
